const InputGroup = ({ label, children, ...props }) => (
    <div
        {...props} className="mt-3">
        <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
        {children}
    </div>
);

export default InputGroup;